<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 20 20">
    <path
      d="M5 12.5L10 7.5L15 12.5"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconChevronUp',
};
</script>

<style scoped lang="scss">
.icon {
  display: inline-block;
  width: 1.25em;
  height: 1.25em;
  fill: none;
  flex-shrink: 0;
  color: $color-gray-700;
}
</style>
